import { degToRad } from 'three/src/math/MathUtils'

export const convertRotationToRadians = (
  rotationInDegrees: [number, number, number]
): [number, number, number] => [
  degToRad(rotationInDegrees[0]),
  degToRad(rotationInDegrees[1]),
  degToRad(rotationInDegrees[2]),
]
